import { DIRECTORY_UPLOAD_MODULES } from "../../../constants/directoryUploadModules";
import DirectoryUploadPage from "./DirectoryUploadPage";

export default function SsdiUploadCraneServices() {
  return <DirectoryUploadPage module={DIRECTORY_UPLOAD_MODULES["crane-services"]} />;
}
